import { css } from '@emotion/css';
import { N0, N50, N400, primary, primaryBackground } from '@assets/colors';

export const styHeaderCol = css`
  background-color: ${N50} !important;
  color: ${N400};
  font-size: 12px;
  border: none !important;
  font-weight: normal;
  height: 32px;
  vertical-align: middle;
  align-items: center;
  display: flex;

  :first-child {
    padding: 4px 4px 4px 16px;
  }
  :not(first-child),
  :not(last-child) {
    padding: 4px;
  }
  :last-child {
    padding: 4px 16px 4px 4px;
  }
`;

export const styTableRow = css`
  cursor: pointer;
`;

export const styTableCol = css`
  :first-child {
    padding: 16px 4px 16px 16px !important;
  }
  :not(first-child),
  :not(last-child) {
    padding: 16px 4px !important;
  }
  :last-child {
    padding: 16px 16px 16px 4px !important;
  }
`;

export const styCompanyLogo = css`
  object-fit: contain;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  margin-right: 8px;
  border: 1px solid ${N50};
`;

const styles = {
  dataContainer: {
    height: 295,
    backgroundColor: N0,
  },
  buttonHoverSelengkapnya: {
    background: 'none',
  },
  buttonFilter: {
    marginRight: 8,
    backgroundColor: N0,
  },
  buttonFilterActive: {
    backgroundColor: primaryBackground,
    borderColor: primary,
    color: primary,
  },
  buttonFilterHover: {
    marginRight: 8,
    backgroundColor: primaryBackground,
    borderColor: primary,
    color: primary,
  },
};

export default styles;
